/**
 * 🏗️ FSD Shared Layer - Activity Utils
 * 
 * ActivityPage에서 사용되는 필터링 관련 유틸리티 함수들
 */ /**
 * 활동을 필터링하는 함수
 */ export var filterActivities = function(activities, filters) {
    return activities.filter(function(activity) {
        // 활동 유형 필터
        if (filters.type !== '전체' && activity.type !== filters.type) {
            return false;
        }
        // 완료 상태 필터
        if (filters.completed === '완료' && !activity.completed) {
            return false;
        }
        if (filters.completed === '미완료' && activity.completed) {
            return false;
        }
        // 기간 필터 (단순화된 버전)
        var activityDate = new Date(activity.date);
        var today = new Date();
        var weekStart = new Date(today);
        weekStart.setDate(today.getDate() - today.getDay());
        var monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
        if (filters.period === '오늘' && activityDate.toDateString() !== today.toDateString()) {
            return false;
        }
        if (filters.period === '이번 주' && activityDate < weekStart) {
            return false;
        }
        if (filters.period === '이번 달' && activityDate < monthStart) {
            return false;
        }
        return true;
    });
};
